import React from 'react'
import {MdFlashOn as FlashOnIcon, MdInfoOutline as InfoIcon} from 'react-icons/md'
import Tooltip from '@packages/justo-parts/lib/components/Tooltip'

import styles from './styles.module.css'

export default function DynamicDelivery({value, color}: {value: number; color?: string}) {
  return (
    <div className={styles.container}>
      <FlashOnIcon className={styles.marginRight} color={color ? color : 'var(--text)'} />
      <div className={styles.marginRight}>{value}</div>
      <Tooltip
        className={styles.tooltip}
        content="El valor del despacho puede verse afectado por la alta demanda">
        <InfoIcon color="grey" />
      </Tooltip>
    </div>
  )
}
